import { useIntl } from "react-intl";

import clsx from "clsx";
import { CourseMaterial } from "./coursesLoader.ts";
import useVirtualStore from "./useVirtualStore.tsx";
import { isMaterialOutOfStock } from "./common/storeProductUtils.ts";
import { Variant } from "../../../../common/api/decimal/methods/product.ts";
import { isTemporarilyOutOfStock } from "../../product/common/productUtils.ts";

export default function StoreStockStatusTag({
  stockItem,
  className,
}: {
  stockItem: CourseMaterial | Variant;
  className?: string;
}) {
  const intl = useIntl();
  const { isVirtualStore } = useVirtualStore();
  let message;
  let color;
  if ("materialFormat" in stockItem) {
    if (
      isVirtualStore &&
      stockItem.product &&
      isMaterialOutOfStock(stockItem)
    ) {
      message = intl.formatMessage({ defaultMessage: "Out of Stock" });
      color = "vst-tag-variant-red";
    }
  } else {
    if (isVirtualStore && isTemporarilyOutOfStock(stockItem)) {
      message = intl.formatMessage({
        defaultMessage: "Temporarily Out of Stock",
      });
      color = "vst-tag-variant-orange";
    }
  }

  if (!message) {
    return null;
  }

  return (
    <div className={clsx("vst-tag", "vst-tag-size-small", color, className)}>
      {message}
    </div>
  );
}
